import {
  LOAD_PLAN_DESCRIPTION_MAP,
  LOAD_PLAN_DESCRIPTION_MAP_FAIL,
  LOAD_PLAN_DESCRIPTION_MAP_SUCCESS,
  LOAD_USER,
  LOAD_USER_AVAILABLE_SUBSCRIPTIONS,
  LOAD_USER_AVAILABLE_SUBSCRIPTIONS_FAIL,
  LOAD_USER_AVAILABLE_SUBSCRIPTIONS_SUCCESS,
  LOAD_USER_FAIL,
  LOAD_USER_REFERRAL_SUBSCRIPTION,
  LOAD_USER_REFERRAL_SUBSCRIPTION_FAIL,
  LOAD_USER_REFERRAL_SUBSCRIPTION_SUCCESS,
  LOAD_USER_SUBSCRIPTION,
  LOAD_USER_SUBSCRIPTION_FAIL,
  LOAD_USER_SUBSCRIPTION_SUCCESS,
  LOAD_USER_SUCCESS,
  LoadPlanDescriptionMapSuccess,
  LoadUserAvailableSubscriptionsSuccess,
  LoadUserReferralSubscriptionSuccess,
  LoadUserSubscriptionSuccess,
  LoadUserSuccess,
  UPDATE_USER_DATA,
  UPDATE_USER_SUBSCRIPTION,
  UpdateUserData,
  USER_LOG_IN,
  USER_LOG_OUT,
  UserAction
} from "../actions";

export interface IUserDataState {
  userData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserSubscriptionState {
  userSubscription: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserAvailableSubscriptionsState {
  userAvailableSubscriptions: {
    platform: any,
    speed_booster: any,
    meta: any,
  };
  loading: boolean;
  loaded: boolean;
}

export interface IUserReferralSubscriptionState {
  userReferralSubscription: any;
  loading: boolean;
  loaded: boolean;
}

export interface IPlanDescriptionMapState {
  planDescriptionMap: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserState {
  userData: IUserDataState;
  userSubscription: IUserSubscriptionState;
  userAvailableSubscriptions: IUserAvailableSubscriptionsState;
  planDescriptionMap: IPlanDescriptionMapState;
  userReferralSubscription: IUserReferralSubscriptionState;
}

export const initialState: IUserState = {
  userData: {
    userData: null,
    loading: false,
    loaded: false
  },
  userSubscription: {
    userSubscription: null,
    loading: false,
    loaded: false
  },
  userAvailableSubscriptions: {
    userAvailableSubscriptions: null,
    loading: false,
    loaded: false
  },
  userReferralSubscription: {
    userReferralSubscription: null,
    loading: false,
    loaded: false
  },
  planDescriptionMap: {
    planDescriptionMap: null,
    loading: false,
    loaded: false
  }
};

export function reducer(state: IUserState = initialState, action: UserAction): IUserState {
  let payload: any;

  switch (action.type) {
    case LOAD_USER:
      return {
        ...state,
        userData: {
          ...state.userData,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_SUCCESS:
      payload = (<LoadUserSuccess>action).payload;

      return {
        ...state,
        userData: {
          ...state.userData,
          userData: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_FAIL:
      return {
        ...state,
        userData: {
          ...state.userData,
          userData: null,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_SUBSCRIPTION:
      return {
        ...state,
        userSubscription: {
          ...state.userSubscription,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_SUBSCRIPTION_SUCCESS:
      payload = (<LoadUserSubscriptionSuccess>action).payload;

      return {
        ...state,
        userSubscription: {
          ...state.userSubscription,
          userSubscription: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_SUBSCRIPTION_FAIL:
      return {
        ...state,
        userSubscription: {
          ...state.userSubscription,
          userSubscription: null,
          loading: false,
          loaded: true
        }
      };

    case UPDATE_USER_SUBSCRIPTION:
      return state;

    case LOAD_USER_AVAILABLE_SUBSCRIPTIONS:
      return {
        ...state,
        userAvailableSubscriptions: {
          ...state.userAvailableSubscriptions,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_AVAILABLE_SUBSCRIPTIONS_SUCCESS:
      payload = (<LoadUserAvailableSubscriptionsSuccess>action).payload;

      return {
        ...state,
        userAvailableSubscriptions: {
          ...state.userAvailableSubscriptions,
          userAvailableSubscriptions: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_AVAILABLE_SUBSCRIPTIONS_FAIL:
      return {
        ...state,
        userAvailableSubscriptions: {
          ...state.userAvailableSubscriptions,
          userAvailableSubscriptions: null,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_REFERRAL_SUBSCRIPTION:
      return {
        ...state,
        userReferralSubscription: {
          ...state.userReferralSubscription,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_REFERRAL_SUBSCRIPTION_SUCCESS:
      payload = (<LoadUserReferralSubscriptionSuccess>action).payload;
      return {
        ...state,
        userReferralSubscription: {
          ...state.userReferralSubscription,
          userReferralSubscription: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_REFERRAL_SUBSCRIPTION_FAIL:
      return {
        ...state,
        userReferralSubscription: {
          ...state.userReferralSubscription,
          userReferralSubscription: null,
          loading: false,
          loaded: true
        }
      };

    case LOAD_PLAN_DESCRIPTION_MAP:
      return {
        ...state,
        planDescriptionMap: {
          ...state.planDescriptionMap,
          loading: true,
          loaded: false
        }
      };

    case LOAD_PLAN_DESCRIPTION_MAP_SUCCESS:
      payload = (<LoadPlanDescriptionMapSuccess>action).payload;

      return {
        ...state,
        planDescriptionMap: {
          ...state.planDescriptionMap,
          planDescriptionMap: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_PLAN_DESCRIPTION_MAP_FAIL:
      return {
        ...state,
        planDescriptionMap: {
          ...state.planDescriptionMap,
          planDescriptionMap: null,
          loading: false,
          loaded: true
        }
      };

    case USER_LOG_IN:

      return {
        ...state
      };

    case UPDATE_USER_DATA:
      payload = (<UpdateUserData>action).payload;

      return {
        ...state,
        userData: {
          ...state.userData,
          userData: payload
        }
      };

    case USER_LOG_OUT:
      return {
        ...state,
        userData: {
          ...state.userData,
          userData: null
        },
        userSubscription: {
          ...state.userSubscription,
          userSubscription: null
        },
        userAvailableSubscriptions: {
          ...state.userAvailableSubscriptions,
          userAvailableSubscriptions: null
        }
      };

  }

  return state;
}
